module.exports = __webpack_public_path__ + "img/banner.17ff7cc6.png";